/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * RechargeInProgress
 *
 */

import React, { memo, useRef } from 'react';
import {
  Modal,
  ModalHeader,
  Button,
  Text,
  Space,
} from '@cashfree-intl/coherent';
import useClickOutside from 'utils/hooks';
import CustomIcon from 'components/CustomIcons';
import { StyledRechargeProgressModal } from '../styled';

function RechargeInProgress({
  open,
  closeModal,
  walletType,
}: {
  open: boolean;
  closeModal: () => void;
  walletType: string;
}) {
  const modalRef = useRef(null);

  useClickOutside(modalRef, closeModal);

  return (
    <Modal
      open={open}
      className="common-modal-wrapper"
      ref={modalRef}
      $maxWidth={480}
    >
      <ModalHeader>
        <div>
          <div className="heading">Add Money to {walletType}</div>
        </div>
        <div
          className="close-modal"
          data-event-name="RechargeInProgressModal_Icon_Close"
          data-ignore-inner-text="true"
          onClick={closeModal}
        >
          <CustomIcon componentName="CLOSE" />
        </div>
      </ModalHeader>
      <StyledRechargeProgressModal>
        <div className="modal-content" style={{ padding: '0' }}>
          <Space alignItems="center" direction="column">
            <CustomIcon componentName="HOUR_GLASS" />
            <Text variant="h16" className="mt-3 mb-1">
              Recharge is in Progress
            </Text>
            <Text variant="b12" color="bodyLight">
              It usually takes some time to reflect the amount in the wallet if
              you
            </Text>
            <Text variant="b12" color="bodyLight">
              recharged. We will update you once it is processed.
            </Text>
            <Text variant="b14" className="mt-2">
              Next Steps
            </Text>
            <Text variant="b12" color="bodyLight">
              When the recharge is complete, activate your wallet to process
              your
            </Text>
            <Text variant="b12" color="bodyLight">
              refunds from {walletType.toLowerCase()}.
            </Text>
            <Button primary size="medium" className="mt-3" onClick={closeModal}>
              Close
            </Button>
          </Space>
        </div>
      </StyledRechargeProgressModal>
    </Modal>
  );
}

export default memo(RechargeInProgress);
